import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormulaireMotDePasseProps } from "@/types/FormulaireMdpType";
import styles from "./FormulaireMotDePasse.module.css";
import { UiButton } from "../ui";

const validationSchema = Yup.object({
  password: Yup.string()
    .required("Le mot de passe est requis")
    .min(8, "Le mot de passe doit contenir au moins 8 caractères")
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/,
      "Le mot de passe doit contenir une majuscule, une minuscule, un chiffre et un symbole"
    ),
  confirmPassword: Yup.string()
    .required("La confirmation du mot de passe est requise")
    .oneOf([Yup.ref("password")], "Les mots de passe ne correspondent pas"),
});

const FormulaireMotDePasse: React.FC<FormulaireMotDePasseProps> = ({
  onSubmit,
  error,
  loading,
}) => {
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onSubmit(values.password, values.confirmPassword);
    },
  });

  return (
    <div className={styles.formContainer}>
      <form onSubmit={formik.handleSubmit}>
        <div className={styles.formGroup}>
          <input
            type="password"
            name="password"
            placeholder="Mon nouveau mot de passe"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`${styles.input} ${
              formik.touched.password && formik.errors.password
                ? styles.error
                : ""
            }`}
            required
          />
          {formik.touched.password && formik.errors.password ? (
            <p className={styles.errorMessage}>{formik.errors.password}</p>
          ) : null}
        </div>

        <div className={styles.formGroup}>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirmer mon mot de passe"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`${styles.input} ${
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? styles.error
                : ""
            }`}
            required
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
            <p className={styles.errorMessage}>
              {formik.errors.confirmPassword}
            </p>
          ) : null}
        </div>

        {error && <p className={styles.messageError}>{error}</p>}

        <UiButton
          type="submit"
          className={styles.submitButton}
          disabled={!formik.isValid || !formik.dirty}
          loading={loading}
        >
          Soumettre
        </UiButton>
      </form>
    </div>
  );
};

export default FormulaireMotDePasse;
